module.exports = __webpack_public_path__ + "static/media/XVIIIh.14fb5090.png";